// dropdown menu open in hover 

let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  // console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });
// menu-drawer open 
document.addEventListener('DOMContentLoaded', function () {
  const menuDrawer = document.querySelector('#Details-menu-drawer-container'); // drawer ka <details> element
  const header = document.querySelector('header.header'); // tumhara main header

  if (menuDrawer && header) {
    menuDrawer.addEventListener('toggle', function () {
      if (menuDrawer.open) {
        header.classList.add('custom-header-active'); // 👈 yaha tum apni custom class add kar sakti ho
      } else {
        header.classList.remove('custom-header-active');
      }
    });
  }
});

// hero-section slider
$(document).ready(function(){
  $('.hero_banner_slider_sec').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    fade: true, 
    cssEase: 'ease-in-out', 
    autoplay: true, 
    autoplaySpeed: 4000, 
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 41"><path d="M20.3 40.8 0 20.5 20.3.2l.7.7L1.3 20.5 21 40.1z"></path></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 41"><path d="M20.3 40.8 0 20.5 20.3.2l.7.7L1.3 20.5 21 40.1z"></path></svg></button>',
  });
});


// newsletter arrow
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".custom-select-wrapper");

  if (!wrapper) return; // Exit if not found

  const select = wrapper.querySelector(".custom-select");

  select.addEventListener("mousedown", function () {
    wrapper.classList.toggle("open");

    // Optional: Close all other selects if multiple exist
    document.querySelectorAll(".custom-select-wrapper").forEach(w => {
      if (w !== wrapper) w.classList.remove("open");
    });
  });

  document.addEventListener("click", function (e) {
    if (!wrapper.contains(e.target)) {
      wrapper.classList.remove("open");
    }
  });
});


// video js
var video = document.getElementById("videoElement");
var playButton = document.getElementById("playButton");
var stopButton = document.getElementById("stopButton");
var muteOnIcon = document.getElementById("muteOnIcon");
var muteOffIcon = document.getElementById("muteOffIcon");

window.addEventListener("load", function () {
  if (!video || !playButton || !stopButton || !muteOnIcon || !muteOffIcon) {
    // Exit if any essential element is missing
    return;
  }

  if (!video.paused) {
    playButton.style.display = "none";
    stopButton.style.display = "inline-block";
  }

  if (video.muted) {
    muteOnIcon.style.display = "block";
    muteOffIcon.style.display = "none";
  } else {
    muteOnIcon.style.display = "none";
    muteOffIcon.style.display = "block";
  }
});

function playVideo() {
  if (!video || !playButton || !stopButton) return;

  video.play();
  playButton.style.display = "none";
  stopButton.style.display = "inline-block";
}

function stopVideo() {
  if (!video || !playButton || !stopButton) return;

  video.pause();
  playButton.style.display = "inline-block";
  stopButton.style.display = "none";
}

function toggleMute() {
  if (!video || !muteOnIcon || !muteOffIcon) return;

  video.muted = !video.muted;
  muteOnIcon.style.display = video.muted ? "block" : "none";
  muteOffIcon.style.display = video.muted ? "none" : "block";
}



// button top
   const button = document.querySelector('.btns');

  const displayButton = () => {
    window.addEventListener('scroll', () => {
      // console.log(window.scrollY);

      if (window.scrollY > 100) {
        button.style.display = "block";
      } else {
        button.style.display = "none";
      }
    });
  };

  const scrollToTop = () => {
    button.addEventListener("click", () => {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      // console.log(event);
    });
  };

  displayButton();
  scrollToTop();


// product page slider start ------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const modalSlider = document.querySelector(".product-media-modal__slider");
    if (modalSlider && !modalSlider.classList.contains("swiper-initialized")) {
      new Swiper(".product-media-modal__slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 900,
        fade: "true",
        // effect: "slide",
        direction: "horizontal",
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        infinite: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

$(document).ready(function(){
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    infinite: false,
    asNavFor: '.slider-nav',
    prevArrow: '<button type="button" class="slick-prev pro_custom_arrow"><svg class="slideshow-arrow" width="23" height="39" viewBox="0 0 23 39" style="transform: scaleX(-1) scale(1);"><path d="M857.005,231.479L858.5,230l18.124,18-18.127,18-1.49-1.48L873.638,248Z" transform="translate(-855 -230)"></path></svg></button>',
    nextArrow: '<button type="button" class="slick-next pro_custom_arrow"><svg class="slideshow-arrow" width="23" height="39" viewBox="0 0 23 39" style="transform: scaleX(1) scale(1);"><path d="M857.005,231.479L858.5,230l18.124,18-18.127,18-1.49-1.48L873.638,248Z" transform="translate(-855 -230)"></path></svg></button>'
  });

  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    vertical: true,
    infinite: false,
    focusOnSelect: true,
    arrows: false
  });
});



// product page slider end ------------------------------------------




document.addEventListener('DOMContentLoaded', function () {


  setTimeout(() => {
    const url = new URL(window.location.href);
    const variantId = url.searchParams.get('variant');

    if (variantId) {
      const variantData = document.querySelector(`.variant-data[data-variant-id="${variantId}"]`);

      if (variantData) {
        const variantImage = variantData.getAttribute('data-variant-image');
        // console.log('Matched Variant Image URL:', variantImage);
        // console.log('Matched Variant Image ID:', variantId);
        const targetImg = document.querySelector(
          '.product-main-image-slider .slick-slide:first-of-type .main-slide img'
        );
        const thumb_targetImg = document.querySelector(
          '.product-thumbnails .slick-slide:first-of-type .thumbnail_product img'
        );
        if (targetImg) {
          targetImg.src = variantImage;
          targetImg.srcset = '';
        }
        if (thumb_targetImg) {
          thumb_targetImg.src = variantImage;
          thumb_targetImg.srcset = '';
        }
      } else {
        // console.log('No matching variant-data found for ID:', variantId);
      }
    } else {
      // console.log('Variant ID not found in URL');
    }
  }, 800);
  
  // if (window.innerWidth <= 768) {
    document.body.addEventListener('click', function (e) {
      const label = e.target.closest('.product-form__input input[type="radio"] + label.variant-label');

      if (label) {
        // ✅ Move existing Slick to the first slide
        const sliderComponent = document.querySelector('.product-main-image-slider');
        if (sliderComponent && sliderComponent.slick) {
          $(sliderComponent).slick("slickGoTo", 0);
          // console.log('Slick moved to first slide');
        } else {
          // console.log('Slick not found or not ready');
        }

        // ⏳ Wait 1 second, then extract variant ID and match with variant data
        setTimeout(() => {
          const url = new URL(window.location.href);
          const variantId = url.searchParams.get('variant');

          if (variantId) {
            const variantData = document.querySelector(`.variant-data[data-variant-id="${variantId}"]`);

            if (variantData) {
              const variantImage = variantData.getAttribute('data-variant-image');
              // console.log('Matched Variant Image URL:', variantImage);
              // console.log('Matched Variant Image ID:', variantId);
              const targetImg = document.querySelector(
                '.product-main-image-slider .slick-slide:first-of-type .main-slide img'
              );
              const thumb_targetImg = document.querySelector(
                '.product-thumbnails .slick-slide:first-of-type .thumbnail_product img'
              );
              if (targetImg) {
                targetImg.src = variantImage;
                targetImg.srcset = '';
              }
              if (thumb_targetImg) {
                thumb_targetImg.src = variantImage;
                thumb_targetImg.srcset = '';
              }
            } else {
              // console.log('No matching variant-data found for ID:', variantId);
            }
          } else {
            // console.log('Variant ID not found in URL');
          }
        }, 800);
      }
    });
  // }
});




$('body .mobile-facets__summary').click(function (event) {
  event.preventDefault();

  const $currentItem = $(this).closest('.mobile-facets__details');
  const $submenu = $currentItem.find('.mobile-facets__submenu');

  // Just toggle the clicked one (don't touch others)
  $submenu.slideToggle();
  $currentItem.toggleClass('active');
});




// Kundeudtalelser page filter jquery
$(document).ready(function () {
  $('#storeFilter').on('change', function () {
    var selectedStore = $(this).val();

    if (selectedStore === 'all') {
      $('.review-card').show();
    } else {
      $('.review-card').each(function () {
        var store = $(this).data('store');
        if (store === selectedStore) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }
  });
  $('#resetFilter').on('click', function () {
    $('#storeFilter').val('all');
    $('.review-card').show();
  });
});
// page load review section show
$(document).ready(function () {
  // Define target container to append all reviews to
  const $targetContainer = $('.pc--kundeudtalelser-section:nth-child(2) .reviews-wrapper');

  if (!$targetContainer.length) return;

  // Loop through all review-card elements not inside the target container
  $('.review-card').each(function () {
    const $this = $(this);
    if (!$this.closest($targetContainer).length) {
      $this.detach().appendTo($targetContainer);
    }
  });
});



// $(document).ready(function () {
//   const $targetContainer = $('.pc--kundeudtalelser-section:nth-child(2) .reviews-wrapper');
//   const $loading = $('#reviews-loading');
//   const cardsPerBatch = 20;
//   let currentIndex = 0;
//   let $allCards = $();

//   if (!$targetContainer.length) return;

//   // Step 1: Move all review cards into the target container
//   $('.review-card').not($targetContainer.find('.review-card')).each(function () {
//     $(this).detach().appendTo($targetContainer).hide();
//   });

//   $allCards = $targetContainer.find('.review-card');

//   // Step 2: Show first batch
//   showNextBatch();

//   // Step 3: On scroll, load more
//   $(window).on('scroll', function () {
//     if (isNearBottom() && currentIndex < $allCards.length) {
//       showNextBatch();
//     }
//   });

//   function showNextBatch() {
//     $loading.show();
//     const nextBatch = $allCards.slice(currentIndex, currentIndex + cardsPerBatch);
//     nextBatch.each(function (i, el) {
//       setTimeout(() => {
//         $(el).fadeIn(200).css('opacity', 1);
//       }, i * 50); // staggered reveal
//     });
//     currentIndex += cardsPerBatch;
//     setTimeout(() => $loading.hide(), nextBatch.length * 50 + 300);
//   }

//   function isNearBottom() {
//     return $(window).scrollTop() + $(window).height() >= $(document).height() - 100;
//   }
// });

// $(document).ready(function () {
//   const $targetContainer = $('.pc--kundeudtalelser-section:nth-child(2) .reviews-wrapper');
//   const $loading = $('#reviews-loading');
//   const cardsPerBatch = 20;
//   let currentIndex = 0;
//   let $allCards = $();

//   if (!$targetContainer.length) return;

//   // Step 1: Move all review cards to the target container and hide them
//   $('.review-card').not($targetContainer.find('.review-card')).each(function () {
//     $(this).detach().appendTo($targetContainer).hide();
//   });

//   $allCards = $targetContainer.find('.review-card');

//   // Step 2: Show the first 20 cards
//   showNextBatch();

//   // Step 3: Infinite scroll to load more
//   $(window).on('scroll', function () {
//     if (isNearBottom() && currentIndex < $allCards.length) {
//       showNextBatch();
//     }
//   });

//   function showNextBatch() {
//     $loading.show();

//     const nextBatch = $allCards.slice(currentIndex, currentIndex + cardsPerBatch);
//     nextBatch.each(function (i, el) {
//       setTimeout(() => {
//         $(el).fadeIn(200).css('opacity', 1);
//       }, i * 50);
//     });

//     currentIndex += cardsPerBatch;

//     setTimeout(() => $loading.hide(), nextBatch.length * 50 + 300);
//   }

//   function isNearBottom() {
//     return $(window).scrollTop() + $(window).height() >= $(document).height() - 100;
//   }

//   // === FILTER LOGIC ===
//   $('#storeFilter').on('change', function () {
//     const selectedStore = $(this).val();
//     let $filteredCards = $targetContainer.find('.review-card');

//     if (selectedStore !== 'all') {
//       $filteredCards = $filteredCards.filter(function () {
//         return $(this).data('store') === selectedStore;
//       });
//     }

//     // Show only filtered cards, hide others
//     $targetContainer.find('.review-card').hide().css('opacity', 0);
//     $filteredCards.show().css('opacity', 1);

//     // Stop loading more during filter
//     $(window).off('scroll');
//   });

//   $('#resetFilter').on('click', function () {
//     $('#storeFilter').val('all');
//     $targetContainer.find('.review-card').hide().css('opacity', 0);
//     currentIndex = 0;
//     showNextBatch();

//     // Resume scroll after reset
//     $(window).on('scroll', function () {
//       if (isNearBottom() && currentIndex < $allCards.length) {
//         showNextBatch();
//       }
//     });
//   });
// });

// $(document).ready(function () {
//   const $loadMoreBtn = $('#loadMoreBtn'); // Adjust selector if different

//   // Hide the button initially
//   $loadMoreBtn.hide();

//   // Scroll detection for triggering load more when .video-grid-section enters view
//   function isInViewport($el) {
//     const rect = $el[0].getBoundingClientRect();
//     return (
//       rect.top <= (window.innerHeight || document.documentElement.clientHeight)
//     );
//   }

//   $(window).on('scroll', function () {
//     const $triggerSection = $('.video-grid-section'); // Section to watch
//     if ($triggerSection.length && isInViewport($triggerSection)) {
//       if ($loadMoreBtn.is(':visible') || $loadMoreBtn.length === 0) return; // Prevent repeat
//       $loadMoreBtn.trigger('click');
//     }
//   });
// });

// Smooth scroll functionality for anchor links
document.addEventListener('DOMContentLoaded', function() {
  // Function to handle smooth scrolling to target sections
  function smoothScrollToElement(targetId) {
    // First try to find by ID
    let targetElement = document.getElementById(targetId);
    
    // If not found by ID, try to find by data-custom-id attribute
    if (!targetElement) {
      targetElement = document.querySelector(`[data-custom-id="${targetId}"]`);
    }
    
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  // Handle all anchor links with hash (#) that start with #
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href^="#"]');
    if (link) {
      const href = link.getAttribute('href');
      const targetId = href.substring(1); // Remove the # symbol
      
      if (targetId) {
        e.preventDefault();
        smoothScrollToElement(targetId);
      }
    }
  });
});



